/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import LoadingSpinner from '../../components/Spinners/LoadingSpinner';
import StatusGridView from './components/StatusGridView';
import StatusGridViewControls from './components/StatusGridViewControls';
import { sortTagsIntoTypes, filterTagsOnInstance, instanceSort, getAvailableRegions } from './utils';

export default class ProductsInstanceList extends React.Component {
  static propTypes = {
    requests: PropTypes.shape({
      instancePreview: PropTypes.object,
    }),
  };

  constructor() {
    super();
    this.state = {
      region: [],
      stack: [],
      allTags: [],
      quickFindText: '',
      availableRegions: []
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleQuickFindChange = this.handleQuickFindChange.bind(this);
    this.filterInstancesList = this.filterInstancesList.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const newState = {};

    if (!this.props.requests.instancePreview.isCompleted &&
      nextProps.requests.instancePreview.isCompleted) {
      const activeInstances = nextProps.requests.instancePreview.value.filter((instance) => {
        return instance.isActive;
      });
      const _stacks = sortTagsIntoTypes(activeInstances, this.handleClick);
      newState.allTags = _stacks;
      newState.availableRegions = getAvailableRegions(activeInstances);
    }

    // reset all filters
    if (nextProps && (nextProps.product !== this.props.product)) {
      newState.quickFindText = '';

      // reset all selectedOptions of all tag types to []
      newState.allTags = Object.assign({}, this.state.allTags);
      Object.entries(newState.allTags).forEach(([, tagState]) => {
        tagState.selectedOptions = [];
      });
    }

    if (Object.keys(newState)) {
      this.setState(newState);
    }
  }

  // name can be region or type of tag
  handleClick(option, name) {
    const stateObject = {};
    if (name === 'region') {
      const regionInState = this.state.region;
      const _index = regionInState.indexOf(option);
      if (_index === -1) {
        // element was not found, lets add it to the state
        stateObject.region = [...regionInState, option];
      } else {
        // element already in the state, time to remove it
        const index = _index;

        // create a copy of the region array
        const newArray = [...regionInState];

        // remove the element from this temporary new array
        newArray.splice(index, 1);

        // set the resulting array onto State's region array
        stateObject.region = newArray;
      }
    } else { // a tag

      const thisTypeTagInState = this.state.allTags[name];
      const _index = thisTypeTagInState.selectedOptions.indexOf(option);
      stateObject.allTags = Object.assign({}, this.state.allTags);

      if (_index === -1) {
        // element was not found, lets add it to the state

        stateObject.allTags[name] = Object.assign(thisTypeTagInState, {
          selectedOptions: [...thisTypeTagInState.selectedOptions, option],
        });
      } else {
        // element already in the state, time to remove it.
        // create a copy of the region array
        const newArray = [...thisTypeTagInState.selectedOptions];

        // remove the element from this temporary new array
        newArray.splice(_index, 1);

        // set the resulting array onto State's region array

        stateObject.allTags[name] = Object.assign(thisTypeTagInState, {
          selectedOptions: newArray,
        });
      }
    }

    this.setState(stateObject);
  }

  handleQuickFindChange(event) {
    const value = event.target.value;
    const filteredQuickFindText = value.replace(/[^\w\s]/gi, '');
    this.setState({
      quickFindText: filteredQuickFindText
    });
  }

  filterInstancesList(instanceGroups) {
    if (!instanceGroups || !_.isArray(instanceGroups)) return [];

    return instanceGroups.filter((i) => {
      const { region, quickFindText, allTags } = this.state;
      let bool = i.isActive;
      // Condition 0: checks if Region, Tag, and QuickFind have been used
      if (region && region.length > 0) bool = bool && region.indexOf(i.location) !== -1;
      if (allTags && Object.keys(allTags).length) bool = bool && filterTagsOnInstance(i, allTags);
      if (quickFindText && quickFindText !== '') {
        bool = bool &&
          i.key.toLowerCase().includes(quickFindText.toLowerCase());
      }

      return bool;
    });
  }

  render() {
    const { instancePreview } = this.props.requests;

    if (!instancePreview.isCompleted) {
      return (
        <LoadingSpinner />
      );
    }

    // apply any existing filter to generate
    // a final instances list to be displayed on the site
    // let mostVisitedInstance = state.setInstance;
    // console.log(state.setInstance);
    const filteredInstancePreview = this.filterInstancesList(instancePreview.value);

    return (
      <div>
        {this.props.displayControls &&
          <StatusGridViewControls
            // allTags={ this.state.allTags }
            selectedOptions={this.state.stack}
            items={filteredInstancePreview.length}
            onQuickFindChange={this.handleQuickFindChange}
            onFilter={this.handleClick}
            selectedRegions={this.state.region}
            regionOptions={this.state.availableRegions}
          />
        }
        <StatusGridView
          instanceGroups={filteredInstancePreview}
        />
      </div>
    );
  }
}
